module.exports = __webpack_public_path__ + "static/media/icn_gold.a289bcfa.svg";